// extracted by mini-css-extract-plugin
export default {"title":"App_title__YS7Xx"};